import React, {useState} from "react";
import {Button} from "react-bootstrap";
import {RequireAuth} from "Components/Security/RequireAuth";
import {ROUTE_PATHS} from "Config/Router/Routes";
import {AdminCrudList} from "Views/Shared/Crud/AdminCrudList";
import {getMailTypes} from "Api/Query/MailTypeQuery";

export const AdminMailTypeList: React.FC = () => {

    const [refresh, setRefresh] = useState<boolean>(false)

    const headers: string[] = ['TIPO', 'ASUNTO']

    return (
        <RequireAuth>
            <AdminCrudList
                canSelectMultipleRows={false}
                title={"Plantilla de emails"}
                headers={headers}
                queryMethod={getMailTypes}
                queryName={"adminMailTypeList"}
                pageSize={50}
                customFilters={<></>}
                refreshSwitch={refresh}
                tableRow={(item: any, key: number) =>
                    <>
                        <td>{item.type}</td>
                        <td>{item.subject}</td>
                        <td className={"text-center align-middle"}>
                            <Button
                                className={"purple-btn btn-sm"}
                                href={ROUTE_PATHS.ADMIN_MAIL_TYPES_EDIT.replace(":id", item.id)}
                            >
                                Modificar
                            </Button>
                        </td>
                    </>
                }
                deleteMethod={() => {}}
            />
        </RequireAuth>
    )
}
